import { RoomBookingServiceBooking } from './room-booking-service-booking.model';
import { Room } from './room.model';
import { Member } from '../member/member.model';
import { CourseInstance } from '../training/course-instance.model';

export class RoomBooking {
  halfDayPrice: number;
  fullDayPrice: number;
  name: string;
  speakerName: string;
  owner: Member | string;
  creator: Member | string;
  startDate: string;
  endDate: string;
  deletedAt?: string | null;
  room: Room; // URI format
  id?: number;
  updatedBy?: Member | string;
  guestsNumber: number;
  serviceBookings: RoomBookingServiceBooking[] | string[];
  courseInstance?: CourseInstance | string;

  // Google Properties
  newToolsEventId?: string;

  constructor(values= {}) {
    Object.assign(this, values);

    if (this.owner instanceof Object) {
      this.owner = new Member(this.owner);
    }

    if (this.creator instanceof Object) {
      this.creator = new Member(this.creator);
    }

    if (this.updatedBy instanceof Object) {
      this.updatedBy = new Member(this.updatedBy);
    }
  }
}
